module.exports = __webpack_public_path__ + "img/me.442bc6f7.svg";